import {
  APPLICATION_SUBMIT_START,
  APPLICATION_SUBMIT_SUCCESS,
  APPLICATION_SUBMIT_FAILURE,
} from '../actions/applicationAction';

const initialState = {
  isSubmitting: false,
  success: false,
  error: null,
};

export default function application(state = initialState, action = {}) {
  switch (action.type) {
    case APPLICATION_SUBMIT_START:
      return { ...state, isSubmitting: true, success: false, error: null };
    case APPLICATION_SUBMIT_SUCCESS:
      return { ...state, isSubmitting: false, success: true };
    case APPLICATION_SUBMIT_FAILURE:
      return { ...state, isSubmitting: false, success: false, error: action.error || 'Error' };
    default:
      return state;
  }
}
